<template>
  <div id="main-dashboard">
    <div id="dashboard-container">
      <div id="dashboard-body">
        <div class="ui container dashboard-info">
          <div class="green-header"  style="position:relative">
            <span class="modal-title">{{ $t('views.secure.home.Registro_usuarios') }}</span>
            <router-link class="item" to="/newControlAccessCard" style="position: absolute;right: 22px;bottom: -50px;">
              <div class="ui right floated small olive labeled icon button rounded">
                <i class="plus icon"></i>{{ $t("components.registeredUsers.Registrar_nuevo") }}
              </div>
            </router-link>
          </div>
          <h3 class="ui dividing header">{{ $t("components.registeredUsers.Listado_de_usuarios") }}</h3>
          <div class="ui grid stackable main_container">
            <div class="sixteen wide column">
              <RegisteredControlAccessCards></RegisteredControlAccessCards>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import RegisteredControlAccessCards from '@/components/RegisteredControlAccessCards.vue';

export default {
  name: 'ControlAccessCards',
  components: {
    RegisteredControlAccessCards
  },
  mounted: function () {
    $('.ui.sidebar').sidebar('hide');
  }
};
</script>
